import { Anchor, Button } from "@svea/design-system-components-react";
import { Stack, Text, useLogin, useText } from "@sveabank/cc-common";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { APPCONFIG } from "../../utils/config";
import { handleLoginError } from "./helpers";
import LoginDev from "./login-dev";

const LoginForm = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { doLogin, loginState } = useLogin();
	const { ENVIRONMENT_NAME } = APPCONFIG;
	const [t, texts] = useText();

	useEffect(() => {
		if (loginState === "LOGGED_IN") navigate("/dashboard");
	}, [loginState]);

	const onLoginClick = async (sameDevice: boolean, ssn: string | null = null) => {
		doLogin(sameDevice, "PROD", ssn).catch((e) => handleLoginError(e, dispatch));
	};

	const isTestEnv = ENVIRONMENT_NAME === "local" || ENVIRONMENT_NAME === "uat";
	return (
		<Stack fullSize justify="between" gap={8}>
			<Text component="p" align="center">
				{t(texts.loginPage.loginForm.description)}
			</Text>
			{isTestEnv ? (
				<LoginDev />
			) : (
				<Stack gap={4} justify="end">
					<Button
						isDisabled={loginState === "PENDING"}
						variant="primary"
						data-testid="bankidButton"
						width="full"
						onPress={() => onLoginClick(true)}
					>
						{t(texts.loginPage.buttonTextSameDevice)}
					</Button>
					<Button variant="secondary" width="full" onPress={() => onLoginClick(false)}>
						{t(texts.loginPage.buttonTextOtherDevice)}
					</Button>
					<span className="text-center">
						<Anchor
							href="https://support.bankid.com/sv/skaffa-mobilt-bankid/skaffa-mobilt-bankid"
							target="_blank"
							rel="noreferrer"
						>
							{t(texts.loginPage.loginHelpLink)}
						</Anchor>
					</span>
				</Stack>
			)}
		</Stack>
	);
};

export default LoginForm;
